import './style.sass';

import React, { Component } from 'react';

import CrewContainer from '../../layouts-components__common-cases/crew-container';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonTitle from '../../../common-components/common-title';

const team = {
    crewList: [
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Полина Герасимова',
            crewItemSubtitle: 'Менеджер веб-проектов',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Татьяна Антипова',
            crewItemSubtitle: 'Менеджер веб-проектов',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Сергей Волошин',
            crewItemSubtitle: 'Backend-техлид',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+6 программистов',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+2 QA-инженера',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+2 веб-дизайнера',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+1 DevOps-инженер',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+1 бизнес-аналитик',
            crewItemSubtitle: '',
            color: true,
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <div className="fondrt-team">
                <FullWrapper>
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={team} />
                </FullWrapper>
            </div>
        );
    }
}

export default Team;
